import { ActionReducer, ActionReducerMap, combineReducers } from '@ngrx/store';

import { CommonBookingState } from '../store.interface';
import { servicesReducer } from './services.reducer';
import { orderReducer } from './order.reducer';
import { seatMapReducer } from './seat-map.reducer';
import { seatsDirtyReducer } from './seats-dirty.reducer';
import { paymentReducer } from './payment.reducer';
import { disruptionReducer } from './disruption.reducer';
import { redirectReducer } from './redirect.reducer';
import { seatSelectionReconciliationReducer } from './seat-selection-reconciliation/seat-selection-reconciliation.reducer';

const commonBookingReducers: ActionReducerMap<CommonBookingState> = {
  services: servicesReducer,
  order: orderReducer,
  seatMap: seatMapReducer,
  seatsDirty: seatsDirtyReducer,
  payment: paymentReducer,
  disruption: disruptionReducer,
  redirect: redirectReducer,
};

const combinedReducer = combineReducers(commonBookingReducers);

export const reducers: ActionReducer<CommonBookingState> = (state, action) =>
  combinedReducer(seatSelectionReconciliationReducer(state, action), action);
